import React from 'react';
import moment from 'moment';

// Components
import DatePicker from '../DatePicker';

const DateFilterTable = ({ startDate, endDate, setStartDate, setEndDate }) => {
    return (
        <div className='row'>
            <div className='col-6 d-flex align-items-center'>
                <label className='me-2 mb-0' style={{ width: '30px' }}>วันที่</label>
                <div className='flex-grow-1'>
                    <DatePicker
                        label=""
                        name=""
                        value={startDate}
                        onChange={(date) => {
                            const newDate = date ? moment(date).format('YYYY-MM-DD') : null;
                            setStartDate(newDate);
                            localStorage.setItem('startDate', newDate);
                        }}
                        disabled={false}
                    />
                </div>
            </div>
            <div className='col-6 d-flex align-items-center'>
                <label className='me-2 mb-0' style={{ width: '25px' }}>ถึง</label>
                <div className='flex-grow-1'>
                    <DatePicker
                        label=""
                        name=""
                        value={endDate}
                        onChange={(date) => {
                            const newDate = date ? moment(date).format('YYYY-MM-DD') : null;
                            setEndDate(newDate);
                            localStorage.setItem('endDate', newDate);
                        }}
                        disabled={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default DateFilterTable;